import { AGGREGATE_NAMES, BACKEND_RESOURCE_NAMES, LOAN_REQUEST_COMMANDS } from 'cpool-constants';
import type { LoanRequestResolver_GetSummary } from 'cpool-tables/backend-resolvers';

export const LEAD_LIST_ACTION_FILTER: Parameters<LoanRequestResolver_GetSummary>[1]['permissionsActionFilter'] = {
    ...Object.fromEntries(Object.values(AGGREGATE_NAMES).map((aggregate) => [aggregate, []])),
    [BACKEND_RESOURCE_NAMES.API]: [],
    [AGGREGATE_NAMES.LOAN_REQUEST]: [
        LOAN_REQUEST_COMMANDS.addAssignedAdvisor,
        LOAN_REQUEST_COMMANDS.assignToUser,
        LOAN_REQUEST_COMMANDS.changeAssignedUser,
        LOAN_REQUEST_COMMANDS.changeStatus,
        LOAN_REQUEST_COMMANDS.createNote,
        LOAN_REQUEST_COMMANDS.startIKProcess,
        LOAN_REQUEST_COMMANDS.removeAssignedUser,
        LOAN_REQUEST_COMMANDS.setActiveUser,
        LOAN_REQUEST_COMMANDS.setResubmission,
    ],
};
